import React, { Component, Fragment } from 'react';
import {Card, Button, message, Form, Input, Modal, Select, Row, Col, Table, Divider, Popconfirm} from 'antd';
import { isEmpty } from 'lodash';
import ReactJson from 'react-json-view'
import { PostForm } from '../../utils/http';
import cn from './index.module.css';

const { Option } = Select;

class RefData extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      /** 查询 */
      searchSymbol: null,
      searchLoading: false,
      searchData: [],
      /** 修改 或者 新增 */
      basicModal: undefined,
      mapInfo: [],
      visible: false,
      isEdit: true,
      setLoading: false,
      // 市场下拉列表
      marketSelectOptions: [],
      // 模版下拉列表
      templateSelectOptions: [],
      // 字段类型下拉列表
      fieldTypeOptions: [],
    }
  }
  componentDidMount() {
    this.handleGetTemplateSelectOptions();
    this.handleGetMarketSelectOptions();
    this.handleGetFieldTypeOptions();
  }
  handleSearchSymbolChange = (searchSymbol) => {
    this.setState({ searchSymbol: searchSymbol && searchSymbol.symbol })
  }
  handleSearchRefData = (searchSymbol) => {
    const { searchLoading } = this.state;
    if (!searchSymbol || searchLoading) return;
    this.setState({ searchLoading: true });
    PostForm({
      url: '/api/refdata/getRefData',
      data: { symbol: searchSymbol },
      success: ({ data }) => {
        this.setState({ searchData: data });
      },
      error: ({ msg = '操作失败' }) => {
        message.error(msg);
      },
      final: () => {
        this.setState({ searchLoading: false });
      },
    });
  }
  handleDelete = (deleteSymbol) => {
    PostForm({
      url: '/api/refdata/removeRefData',
      data: { symbol: deleteSymbol },
      success: ({ data, msg = '删除成功' }) => {
        message.success(msg);
        this.handleSearchRefData(data);
      },
      error: ({ msg = '操作失败' }) => {
        message.error(msg);
      },
    });
  }
  handleSetRefData = () => {
    this.formRef.current
        .validateFields()
        .then(async (values) => {
          const { mapInfo, isEdit } = this.state;
          const { symbol, cnName, enName, market, template } = values;
          this.setState({ setLoading: true });
          const data = {
            symbol: symbol,
            cnName: cnName,
            enName: enName,
            market: market,
            refdata: JSON.stringify(mapInfo),
          };
          if (isEdit) data['template'] = template;
          const type = isEdit ? 'addRefData' : 'updateRefData';
          PostForm({
            url: `/api/refdata/${type}`,
            data: data,
            success: ({ data, msg = '操作成功' }) => {
              message.success(msg);
              this.handleSearchRefData(data);
            },
            error: ({ msg = '操作失败' }) => {
              message.error(msg);
            },
            final: () => {
              this.setState({ setLoading: false });
              this.handleModalHide();
            },
          });
        });
  }
  handleShowRefDataDetail = (item) => {
    /** 展示详情 */
    this.setState({ refDataDel: item })
  }
  handleGetTemplateSelectOptions = () => {
    /** 根据type请求模版 */
    PostForm({
      url: '/api/refdata/getRefDataTemplateEntry',
      data: {},
      success: ({ data: data = [] }) => {
        this.setState({ templateSelectOptions: data })
      },
      error: ({ msg = '获取失败' }) => {
        message.error(msg);
      },
    });
  }
  handleGetMarketSelectOptions = () => {
    /** 请求市场 */
    PostForm({
      url: '/api/refdata/getMarket',
      data: {},
      success: ({data: data = []}) => {
        this.setState({ marketSelectOptions: data })
      },
      error: ({ msg = '获取失败' }) => {
        message.error(msg);
      },
    });
  }
  handleGetFieldTypeOptions = () => {
    /** 请求字段类型 */
    PostForm({
      url: '/api/refdata/getFieldType',
      data: {},
      success: ({data: data = []}) => {
        this.setState({ fieldTypeOptions: data })
      },
      error: ({ msg = '获取失败' }) => {
        message.error(msg);
      },
    });
  }
  handleModalShow = (basicModal = {}) => {
    this.setState({
      visible: true,
      basicModal: basicModal,
      isEdit: isEmpty(basicModal),
      mapInfo: []
    });
  }
  handleModalHide = () => {
    this.setState({
      visible: false,
      basicModal: {},
      mapInfo: []
    });
  }
  handleChangneField = (value, type, index) => {
    const { mapInfo } = this.state;
    mapInfo[index][type] = value;
    this.setState({ mapInfo: [...mapInfo] }, this.checkError);
  }
  handleDelField = (index) => {
    const { mapInfo } = this.state;
    mapInfo.splice(index, 1);
    this.setState({ mapInfo: [...mapInfo] }, this.checkError);
  }
  // 错误提示
  checkError = (isSubmit) => {
    const { mapInfo } = this.state;
    let isErr = false;
    const newMaps = mapInfo.map((item) => {
      const { fieldName, fieldValue, fieldType, fieldNameErr, fieldValueErr, fieldTypeErr } = item;
      const nV = { fieldName, fieldValue, fieldType };
      // 判断为空
      if (!fieldName) nV.fieldNameErr = isSubmit ? '字段名称不可为空' : fieldNameErr;
      if (!fieldValue) nV.fieldValueErr = isSubmit ? '字段值不可为空' : fieldValueErr;
      if (!fieldType) nV.fieldTypeErr = isSubmit ? '字段类型不可为空' : fieldTypeErr;
      // 判断列所有字段名称存在重复
      const totalFieldName = [];
      mapInfo.forEach(v => totalFieldName.push(v.fieldName));
      const fieldNameRepeat = totalFieldName.filter(v => (v && v === fieldName));
      if (fieldNameRepeat.length > 1) nV.fieldNameErr = '存在重复的字段名称';
      if (nV.fieldNameErr || nV.fieldValueErr || nV.fieldTypeErr) isErr = true;
      return nV;
    });
    this.setState({ mapInfo: newMaps });
    return isErr;
  }
  geFieldFormItem = (item, index) => {
    const { fieldName, fieldValue, fieldType, fieldNameErr, fieldValueErr, fieldTypeErr } = item;
    return (
        <Row key={index} style={{ width: '400px' }}>
          <Col span={8}>
            <Input
                style={{ minWidth: 80 }}
                value={fieldName}
                onChange={v => this.handleChangneField(v.target.value, 'fieldName', index)}
            >
            </Input>
            {
              fieldNameErr && (
                  <div className='up' style={{ fontSize: '12px', lineHeight: '20px' }}>
                    {fieldNameErr}
                  </div>
              )}
          </Col>
          <Col span={8}>
            <Input
                style={{ minWidth: 80 }}
                value={fieldValue}
                onChange={v => this.handleChangneField(v.target.value, 'fieldValue', index)}
            >
            </Input>
            {
              fieldValueErr && (
                  <div className='up' style={{ fontSize: '12px', lineHeight: '20px' }}>
                    {fieldValueErr}
                  </div>
              )}
          </Col>
          <Col span={8}>
            <Select
                showSearch
                style={{ minWidth: 80 }}
                optionFilterProp="children"
                value={fieldType}
                onChange={v => this.handleChangneField(v, 'fieldType', index)}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
              {
                this.state.fieldTypeOptions.map(value => (
                    <Option key={value} value={value}>{value}</Option>
                ))
              }
            </Select>
            {
              fieldTypeErr && (
                  <div className='up' style={{ fontSize: '12px', lineHeight: '20px' }}>
                    {fieldTypeErr}
                  </div>
              )}
          </Col>
          <Col offset={1} span={2}>
            <Button
                onClick={() => this.handleDelField(index)}
                shape="round"
                size="small"
                icon='close'
                style={{ fontSize: '10px' }}
            ></Button>
          </Col>
        </Row>
    );
  }
  render() {
    const {
      searchData, mapInfo, templateSelectOptions, marketSelectOptions, basicModal, visible, isEdit, setLoading, refDataDel = {}
    } = this.state;
    const { copy: dtlCopy, ...refDataRest } = refDataDel;
    const cancelModal = () => this.setState({ refDataDel: undefined });
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      style: { marginBottom: 0 },
    };
    const formSmallItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 6 },
      style: { marginBottom: 0 },
    };
    return (
      <Card>
        <Modal
          title="详情"
          visible={!!dtlCopy}
          onCancel={cancelModal}
          footer={<Button type="primary" onClick={cancelModal}>关闭</Button>}
        >
          <ReactJson src={refDataRest} />
        </Modal>
        <Card
          title={
            <Form.Item label="股票" className={cn.symbol} style={{ marginBottom: 0 }}>
              <Input.Search
                placeholder="请输入查询的股票"
                enterButton={<Button>查询</Button>}
                onSearch={this.handleSearchRefData}
              />
            </Form.Item>
          }
          extra={
            <Button
                type="primary"
                onClick={() => this.handleModalShow()}
            >新增</Button>}
          bordered
        >
          <Table
            dataSource={searchData}
            size="small"
            id="copy"
            columns={
              [
                { title: 'ID', dataIndex: '_id', align: 'center' },
                {
                  title: '操作',
                  render: (record) => (
                      <Fragment>
                        <span className="link" onClick={() => this.handleShowRefDataDetail(record)}>展开</span>
                        <Divider type="vertical" />
                        <span className="link" onClick={() => this.handleModalShow(record)}>修改</span>
                        <Divider type="vertical" />
                        <Popconfirm
                            placement="leftTop"
                            title="确定要删除吗?"
                            onConfirm={() => this.handleDelete(record._id)}
                            okText="确定"
                            cancelText="取消"
                        >
                          <span className="link">删除</span>
                        </Popconfirm>
                      </Fragment>
                  )
                },
              ]
            }
            pagination={{ pageSize: 5 }}
          />
          {visible && (
              <Modal
                  title={isEdit ? '新增' : '修改'}
                  visible={visible}
                  onCancel={() => this.handleModalHide()}
                  footer={[
                    <Button key="back" onClick={() => this.handleModalHide()}>取消</Button>,
                    <Button loading={setLoading} key="submit" type="primary" onClick={this.handleSetRefData}>确定</Button>
                  ]}
                  width={600}
              >
                <Form
                    ref={this.formRef}
                    initialValues={{
                      symbol: isEdit ? '' : basicModal.fields.Code,
                      cnName: isEdit ? '' : basicModal.fields.CNName,
                      enName: isEdit ? '' : basicModal.fields.ENName,
                      market: isEdit ? '' : basicModal.fields.Category,
                      template: '',
                    }}
                >
                  <Form.Item
                      label="股票"
                      name="symbol"
                      rules={[{ required: true, message: '请输入股票!' }]}
                      {...formItemLayout}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                      label="中文名"
                      name="cnName"
                      rules={[{ required: true, message: '请输入中文名!' }]}
                      {...formItemLayout}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                      label="英文名"
                      name="enName"
                      rules={[{ required: true, message: '请输入英文名!' }]}
                      {...formItemLayout}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                      label="市场"
                      name="market"
                      rules={[{ required: true, message: '请选择市场!' }]}
                      {...formSmallItemLayout}
                  >
                    <Select
                        showSearch
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.split('.')[0].toLowerCase()) >= 0
                        }
                    >
                      {marketSelectOptions.map((item) => (
                          <Option key={item} value={item}>
                            {item}
                          </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {isEdit && <Form.Item
                      label="模板"
                      name="template"
                      rules={[{ required: true, message: '请选择模板!' }]}
                      {...formSmallItemLayout}
                  >
                    <Select
                        showSearch
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.split('.')[0].toLowerCase()) >= 0
                        }
                    >
                      {templateSelectOptions.map((item) => (
                          <Option key={item} value={item}>
                            {item}
                          </Option>
                      ))}
                    </Select>
                  </Form.Item>}
                  <Fragment>
                    <Divider style={{ margin: '5px' }}></Divider>
                    <Form.Item {...formItemLayout}>
                      <Row style={{ width: '400px' }}>
                        <Col span={8} style={{ textAlign: 'center' }}>字段名称</Col>
                        <Col span={8} style={{ textAlign: 'center' }}>字段值</Col>
                        <Col span={8} style={{ textAlign: 'center' }}>字段类型</Col>
                      </Row>
                      <Divider style={{ margin: '0px', width: '236px' }} />
                      {mapInfo.map((item, index) => (
                          <Form.Item colon={false} {...formItemLayout}>
                            {this.geFieldFormItem(item, index)}
                          </Form.Item>
                      ))}
                      {
                        mapInfo.length < 30 &&
                        <Button
                            onClick={() => this.setState({ mapInfo: [...mapInfo, {}] })}
                            type="dashed"
                            block
                            size='small'
                        >
                          新增
                        </Button>
                      }
                    </Form.Item>
                  </Fragment>
                </Form>
              </Modal>
          )}
        </Card>
      </Card>
    )
  }
}

export default RefData;
// export default RefData
